/* Flow storefront haptics: Android browsers only. */
(function () {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  var hapticsDebug = false;
  try {
    hapticsDebug = new URLSearchParams(window.location.search).has('flow_haptics_debug');
  } catch (error) {
    hapticsDebug = false;
  }

  var PRODUCT_PAGE_SELECTOR = 'product-info[data-page-type="product"]';
  var HAMBURGER_SELECTOR = 'header-drawer > details > summary.header__icon--menu';
  var HAPTIC_CLICK_SELECTOR = [
    '.product-form__submit',
    '.cart__checkout-button',
    '.quantity__button',
    '[data-fsc-tab]',
    '.faq_header',
    '.product__media-toggle',
    '.slider-button',
    '.csm-mobile-nav__toggle',
    '.header__heading-link',
    '.csm-mobile-nav__logo',
    '.hero_primary_btn',
    '.hero_secondary_btn',
    '.hiw_card_header',
    '.dock_btn',
    '.dock-card[data-variant-id]',
    '[data-offer-pack-card]',
    '.wfw_shop_btn',
  ].join(',');

  var HAPTIC_PATTERNS = {
    success: [30, 60, 40],
    warning: [40, 100, 40],
    error: [40, 40, 40, 40, 40],
    light: [15],
    medium: [25],
    heavy: [35],
    soft: [40],
    rigid: [10],
    selection: [8],
    nudge: [80, 80, 50],
    buzz: [1000],
  };

  var pointerTriggeredElements = new WeakSet();

  function hasNativeVibrate() {
    return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
  }

  function isAndroidDevice() {
    if (typeof navigator === 'undefined') return false;

    var userAgent = navigator.userAgent || '';
    var platform = navigator.platform || '';
    if (navigator.userAgentData && navigator.userAgentData.platform) {
      platform += ' ' + navigator.userAgentData.platform;
    }

    return /Android/i.test(userAgent + ' ' + platform);
  }

  function isEnabled() {
    return isAndroidDevice() && hasNativeVibrate();
  }

  function normalizeNumber(value, max) {
    if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) return null;
    return Math.min(max, Math.round(value));
  }

  function appendStep(output, step) {
    if (!step) return;

    var delay = normalizeNumber(step.delay || 0, 1000);
    var duration = normalizeNumber(step.duration || 0, 1000);
    if (delay === null || duration === null) return;

    if (delay > 0) {
      if (output.length > 0 && output.length % 2 === 0) {
        output[output.length - 1] += delay;
      } else {
        if (output.length === 0) output.push(0);
        output.push(delay);
      }
    }

    if (duration > 0) output.push(duration);
  }

  function normalizePattern(input) {
    if (typeof input === 'string') {
      return HAPTIC_PATTERNS[input] ? HAPTIC_PATTERNS[input].slice() : null;
    }

    if (typeof input === 'number') {
      var duration = normalizeNumber(input, 1000);
      return duration && duration > 0 ? [duration] : null;
    }

    if (Array.isArray(input)) {
      if (!input.length) return null;

      if (typeof input[0] === 'number') {
        var numericPattern = input
          .map(function (part) { return normalizeNumber(part, 1000); })
          .filter(function (part) { return part !== null; });
        return numericPattern.length ? numericPattern : null;
      }

      var output = [];
      input.forEach(function (step) { appendStep(output, step); });
      return output.length ? output : null;
    }

    if (input && Array.isArray(input.pattern)) {
      return normalizePattern(input.pattern);
    }

    return null;
  }

  function trigger(pattern) {
    var nativePattern = normalizePattern(pattern);
    var enabled = isEnabled();

    if (hapticsDebug) {
      console.debug('[Flow haptics] trigger', {
        enabled: enabled,
        android: isAndroidDevice(),
        nativeVibrate: hasNativeVibrate(),
        pattern: pattern,
        nativePattern: nativePattern,
      });
    }

    if (!enabled || !nativePattern) return false;

    try {
      return navigator.vibrate(nativePattern) !== false;
    } catch (error) {
      if (hapticsDebug) console.debug('[Flow haptics] vibrate failed', error);
      return false;
    }
  }

  function isMainProductGallery(target) {
    return !!closest(target, PRODUCT_PAGE_SELECTOR);
  }

  function closest(target, selector) {
    if (!target) return null;

    if (target.nodeType !== 1) {
      target = target.parentElement;
    }

    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target.closest(selector);
  }

  function getHapticTarget(target) {
    return closest(target, HAPTIC_CLICK_SELECTOR);
  }

  function getPatternForTarget(target) {
    if (
      closest(target, '.product-form__submit') ||
      closest(target, '.cart__checkout-button') ||
      closest(target, '.hero_primary_btn') ||
      closest(target, '.dock_btn') ||
      closest(target, '.wfw_shop_btn')
    ) {
      return 'success';
    }

    if (
      closest(target, '.quantity__button') ||
      closest(target, '[data-fsc-tab]') ||
      closest(target, '.faq_header') ||
      closest(target, '.product__media-toggle') ||
      closest(target, '.slider-button') ||
      closest(target, '.header__heading-link') ||
      closest(target, '.csm-mobile-nav__logo') ||
      closest(target, '.hero_secondary_btn') ||
      closest(target, '.hiw_card_header')
    ) {
      return 'nudge';
    }

    if (
      closest(target, '.csm-mobile-nav__toggle') ||
      closest(target, '.dock-card[data-variant-id]') ||
      closest(target, '[data-offer-pack-card]')
    ) {
      return 'selection';
    }

    return null;
  }

  function markPointerTriggered(element) {
    pointerTriggeredElements.add(element);
    window.setTimeout(function () {
      pointerTriggeredElements.delete(element);
    }, 1000);
  }

  function bindHamburgerHaptics(root) {
    (root || document).querySelectorAll(HAMBURGER_SELECTOR).forEach(function (summary) {
      if (summary.dataset.hapticsBound === 'true') return;

      summary.addEventListener('pointerdown', function () {
        markPointerTriggered(summary);
        trigger('selection');
      }, { passive: true });
      summary.addEventListener('click', function () {
        if (pointerTriggeredElements.has(summary)) {
          pointerTriggeredElements.delete(summary);
          return;
        }
        trigger('selection');
      });
      summary.dataset.hapticsBound = 'true';
    });
  }

  document.addEventListener('pointerdown', function (event) {
    var hapticTarget = getHapticTarget(event.target);
    if (!hapticTarget) return;

    var pattern = getPatternForTarget(hapticTarget);
    if (!pattern) return;

    markPointerTriggered(hapticTarget);
    trigger(pattern);
  }, { passive: true });

  document.addEventListener('click', function (event) {
    var hapticTarget = getHapticTarget(event.target);
    if (!hapticTarget) return;

    if (pointerTriggeredElements.has(hapticTarget)) {
      pointerTriggeredElements.delete(hapticTarget);
      return;
    }

    var pattern = getPatternForTarget(hapticTarget);
    if (pattern) trigger(pattern);
  });

  document.addEventListener('change', function (event) {
    if (event.isTrusted === false) return;

    if (closest(event.target, '[data-flow-plus-checkbox], [data-flow-plus-option-input]')) {
      trigger('selection');
    }
  });

  document.addEventListener('product-gallery:media-change', function (event) {
    if (!isMainProductGallery(event.target)) return;
    trigger('selection');
  });

  bindHamburgerHaptics(document);

  if (hapticsDebug) {
    window.FlowStorefrontHaptics = {
      isEnabled: isEnabled,
      isAndroidDevice: isAndroidDevice,
      hasNativeVibrate: hasNativeVibrate,
      patterns: HAPTIC_PATTERNS,
      trigger: trigger,
    };
    console.debug('[Flow haptics] ready', {
      enabled: isEnabled(),
      android: isAndroidDevice(),
      nativeVibrate: hasNativeVibrate(),
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindHamburgerHaptics(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      trigger('buzz');
    });
    subscribe(PUB_SUB_EVENTS.cartError, function () {
      trigger('error');
    });
  }
})();
